// extracted by css-extract-rspack-plugin
export default {"FilterFooterRoot":"fLo6y"};